/**
 * Maps persisted API enum to the same marketing labels as the client apps.
 * @param {string | null | undefined} value NOW | SOON | TOMORROW
 * @returns {string}
 */
export function formatClientDeliveryWindowOption(value) {
  if (value == null || value === '') return '—';
  switch (String(value).toUpperCase()) {
    case 'NOW':
      return 'pkup NOW (2 hours)';
    case 'SOON':
      return 'pkup SOON (4 hours)';
    case 'TOMORROW':
      return 'pkup TOMORROW';
    default:
      return '—';
  }
}
